/**
 * @generated SignedSource<<89d54dc077be10e22ee5964f869a3abe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CubeDimensionEnum = "COHORT_MONTH" | "COUNTRY" | "PLAN_TIER" | "SEAT_BAND" | "TENURE_BAND" | "%future added value";
export type explorePage_Query$variables = {
  from?: string | null | undefined;
  groupBy?: CubeDimensionEnum | null | undefined;
  seatBands?: ReadonlyArray<string> | null | undefined;
};
export type explorePage_Query$data = {
  readonly cube: {
    readonly groupBy: string | null | undefined;
    readonly series: ReadonlyArray<{
      readonly key: string;
      readonly monthly: ReadonlyArray<{
        readonly activeLogos: number;
        readonly arr: number;
        readonly churnedLogos: number;
        readonly churnedMrr: number;
        readonly contractionMrr: number;
        readonly expansionMrr: number;
        readonly month: string;
        readonly mrr: number;
        readonly newLogos: number;
        readonly newMrr: number;
        readonly reactivationMrr: number;
      }>;
    }>;
  };
};
export type explorePage_Query = {
  response: explorePage_Query$data;
  variables: explorePage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seatBands"
},
v3 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "groupBy",
    "variableName": "groupBy"
  },
  {
    "kind": "Variable",
    "name": "seatBands",
    "variableName": "seatBands"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupBy",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mrr",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "arr",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeLogos",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newLogos",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "churnedLogos",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newMrr",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expansionMrr",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contractionMrr",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "churnedMrr",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reactivationMrr",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "explorePage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CubeResult",
        "kind": "LinkedField",
        "name": "cube",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CubeSeries",
            "kind": "LinkedField",
            "name": "series",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CubePoint",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "explorePage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CubeResult",
        "kind": "LinkedField",
        "name": "cube",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CubeSeries",
            "kind": "LinkedField",
            "name": "series",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CubePoint",
                "kind": "LinkedField",
                "name": "monthly",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "09e30687c9511fef2b8977d3545c8b42",
    "id": null,
    "metadata": {},
    "name": "explorePage_Query",
    "operationKind": "query",
    "text": "query explorePage_Query(\n  $groupBy: CubeDimensionEnum\n  $seatBands: [String!]\n  $from: String\n) {\n  cube(groupBy: $groupBy, seatBands: $seatBands, from: $from) {\n    groupBy\n    series {\n      key\n      monthly {\n        month\n        mrr\n        arr\n        activeLogos\n        newLogos\n        churnedLogos\n        newMrr\n        expansionMrr\n        contractionMrr\n        churnedMrr\n        reactivationMrr\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "27fe76bf4caef3087aa88473f88e5849";

export default node;
